import BaseModelAPI from '../BaseModelAPI';

export default class ApproverState extends BaseModelAPI {
	static entity = 'approverstate';
	static entityName = 'approverstate';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.approvalInstanceId = '';
			this.approvalInstance = {};
			this.approverTypeId = '';
			this.approverType = {};
			this.approvalStructureId = '';
			this.approvalStructure = {};
			this.approverLevel = 0;
			this.approverUserId = '';
			this.approverUser = {};
			this.activityStateId = '';
			this.activityState = {};
			this.approvalConfigurationInstanceDetailId = '';
			this.approvalConfigurationInstanceDetail = {};
			this.sequence = 0;
			this.storedProcedureName = '';
			this.isSendNotification = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}